/* eslint-disable @typescript-eslint/no-explicit-any,no-console */
import { AttributeConfig, type InputAttributeConfig } from "@src/context/attributeConfig/AttributeConfigContext";
import { apiKeyVar } from "@src/utils/apollo/links/apiKeyLink";
import {
    type SPFAddToCartProcessedEvent,
    type SPFArticleInfo,
    type SPFArticleInfosEvent,
    SPFAvailabilityStatus,
    SPFWishlistInfoDetailSchema,
    type SPFWishlistInfoEvent,
} from "@src/utils/events";

export const isSPFArticleInfosEvent = (value: any): value is SPFArticleInfosEvent => {
    if (value.detail !== undefined && typeof value.detail === "object") {
        if (value.detail.infos !== undefined && Array.isArray(value.detail.infos)) {
            return true;
        }
    }

    return false;
};

export const isSPFAddToCartProcessedEvent = (value: any): value is SPFAddToCartProcessedEvent => {
    if (value.detail !== undefined && typeof value.detail === "object") {
        if (
            value.detail.successfulArticleNumbers !== undefined &&
            Array.isArray(value.detail.successfulArticleNumbers) &&
            value.detail.successfulArticleNumbers.every((item: any) => typeof item === "string")
        ) {
            if (value.detail.errorArticleNumbers !== undefined) {
                if (
                    Array.isArray(value.detail.errorArticleNumbers) &&
                    value.detail.errorArticleNumbers.every((item: any) => typeof item === "string")
                ) {
                    return true;
                } else {
                    console.error(`pmag-spare-parts-finder SPFAddToCartProcessedEvent invalid attribute: 'errorArticleNumbers'`);
                }
            }

            return true;
        } else {
            console.error(`pmag-spare-parts-finder SPFAddToCartProcessedEvent invalid attribute: 'successfulArticleNumbers'`);
        }
    }

    return false;
};

export const isSPFWishlistInfoEvent = (value: any): value is SPFWishlistInfoEvent => {
    const result = SPFWishlistInfoDetailSchema.safeParse(value);
    if (!result.success) {
        console.error(result.error);

        return false;
    }

    return true;
};

const isAvailabilityStatus = (value: any): value is SPFAvailabilityStatus => {
    return Object.values(SPFAvailabilityStatus).includes(value);
};

export const isSPFArticleInfo = (value: any): SPFArticleInfo | undefined => {
    let errorCount = 0;
    if (typeof value.articleNumber !== "string") {
        console.error(`pmag-spare-parts-finder SPFArticleInfo invalid attribute: 'articleNumber'`);
        errorCount++;
    }
    if (typeof value.price !== "number" && value.price !== undefined) {
        console.error(`pmag-spare-parts-finder SPFArticleInfo invalid attribute: 'price' for article with id: ${value.articleNumber}`);
        errorCount++;
    }
    if (typeof value.currency !== "string" && value.price !== undefined) {
        console.error(`pmag-spare-parts-finder SPFArticleInfo invalid attribute: 'currency' for article with id: ${value.articleNumber}`);
        errorCount++;
    }
    if (typeof value.availabilityText !== "string" && value.availabilityText !== undefined) {
        console.error(`pmag-spare-parts-finder SPFArticleInfo invalid attribute: 'availabilityText' for article with id: ${value.articleNumber}`);
        errorCount++;
    }
    if (value.availability !== undefined) {
        if (typeof value.availability !== "string") {
            console.error(`pmag-spare-parts-finder SPFArticleInfo invalid attribute: 'availability' for article with id: ${value.articleNumber}`);
            errorCount++;
        } else {
            if (!isAvailabilityStatus(value.availability)) {
                console.warn(
                    `pmag-spare-parts-finder SPFArticleInfo unsupported 'availability' detected for article with id: ${value.articleNumber}`,
                );
                value.availability = SPFAvailabilityStatus.Unknown;
            }
        }
    }

    if (errorCount > 0) return;

    return value as SPFArticleInfo;
};

// Type guard function to validate if the parsed object conforms to the Config interface
export const isValidAttributeConfig = (configString: string): InputAttributeConfig | undefined => {
    try {
        const result = AttributeConfig.safeParse(JSON.parse(configString));
        if (!result.success) {
            console.error(result.error.issues);

            return;
        }

        apiKeyVar(result.data.apiKey);

        return result.data;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        console.error(`pmag-spare-parts-finder invalid JSON string`);

        return;
    }
};
